import { render, staticRenderFns } from "./BatchForm.vue?vue&type=template&id=2ba6cd4e&scoped=true"
import script from "./BatchForm.vue?vue&type=script&lang=js"
export * from "./BatchForm.vue?vue&type=script&lang=js"
import style0 from "./BatchForm.vue?vue&type=style&index=0&id=2ba6cd4e&prod&lang=less"
import style1 from "./BatchForm.vue?vue&type=style&index=1&id=2ba6cd4e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba6cd4e",
  null
  
)

export default component.exports